import React from 'react';
import { TableHeader } from './TableHeader';
import { TableBody } from './TableBody';
import classes from './ReportTable.module.css';
import { ReportTableProps } from './interfaces';

const ReportTable: React.FC<ReportTableProps> = ({
  columns,
  rows,
  actions,
  isInCheckIn,
  isInReport,
}) => {
  return (
    <div className={classes.tableContainer}>
      <table className={classes.reportTable} border={0} cellSpacing={0}>
        <TableHeader columns={columns} actions={actions} />
        <TableBody
          rows={rows}
          actions={actions}
          columns={columns}
          isInCheckIn={isInCheckIn}
          isInReport={isInReport}
        />
      </table>
    </div>
  );
};

export { ReportTable };
